export default {
  data() {
    return {
      mode: 'request',
      resettingPassword: false,
      resetPasswordForm: {
        newPassword: '',
        confirmPassword: '',
      },
      resetPasswordFormRules: {
        password: [
          { required: true, message: 'Please enter a new password', trigger: 'blur' },
          { min: 6, message: 'Password must be at least 6 characters', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: 'Please confirm your new password', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value !== this.resetPasswordForm.newPassword) {
                callback(new Error('Passwords do not match'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    createNewPassword() {
      this.$refs.resetPasswordForm.validate((valid) => {
        if (valid) {
          this.resettingPassword = true;
          // Call API or handle password reset logic
          console.log('Password reset with:', this.resetPasswordForm);
          // Simulate API response
          setTimeout(() => {
            this.resettingPassword = false;
            this.$router.push({ name: 'login-page' });
          }, 2000);
        } else {
          console.error('Validation failed');
        }
      });
    },
    goToLogin() {
      this.$router.push({ name: 'login-page' });
    },
  },
};